import { type UseQueryResult, useQuery } from 'react-query';
import {
  NotificationTemplateService,
  PagedResultDto_NotificationMatrixTemplateDto,
} from '@wealthlane/api-services/wealthlane-notification-service';
import { TableParams } from '../../types/common';

const useGetEmailTemplates = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<PagedResultDto_NotificationMatrixTemplateDto | undefined, unknown> => {
  const {
    notificationMediumIds,
    notificationCategories,
    recipientTypes,
    filter,
    isActive,
    sorting,
    skipCount,
    maxResultCount,
  } = tableInfo;

  return useQuery(
    [
      'getEmailTemplates',
      notificationMediumIds,
      notificationCategories,
      recipientTypes,
      filter,
      isActive,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      return await handleRequest(
        NotificationTemplateService.getApiNotificationApiAppNotificationTemplate(
          null,
          notificationMediumIds ? [notificationMediumIds] : undefined,
          notificationCategories ? [notificationCategories] : undefined,
          recipientTypes ? (Array.isArray(recipientTypes) ? recipientTypes : [recipientTypes]) : undefined,
          filter,
          isActive,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );
};

export default useGetEmailTemplates;
